/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export type DChartCoordinateTickMinorStepFunction = (
	majorStep: number,
	minorCount: number
) => number;
